import { useEffect, useState } from 'react';
import { Styled } from './sidebar.styled';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

type Sidebar = {
    children: any;
    collapse?: boolean;
    disableCollapse?: boolean;
};

const SidebarComponent: React.FC<Sidebar> = ({
    children,
    collapse: defaultValue,
    disableCollapse,
}) => {
    const [collapse, updateCollapse] = useState<boolean>(false);

    useEffect(() => {
        if (defaultValue) updateCollapse(defaultValue);
    }, [defaultValue]);

    const doCollapse = () => {
        // تغییر وضعیت اسکرول برای اعمال شدن روی کامپوننت استیکی
        window.scrollTo(window.scrollX, window.scrollY - 1);

        updateCollapse(!collapse);
        localStorage.setItem('sidebar_collapse', !collapse + '');
    };

    return (
        <Styled.Sidebar
            className={'sidebar-wrapper ' + (!collapse && 'collapse ')}>
            <Styled.SidebarContent>
                {disableCollapse !== true && (
                    <Styled.CollapseButton onClick={doCollapse}>
                        {collapse ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </Styled.CollapseButton>
                )}
                {typeof children === 'function'
                    ? children({ collapse })
                    : children}
            </Styled.SidebarContent>
        </Styled.Sidebar>
    );
};

export default SidebarComponent;
